import { RouteObject } from 'react-router-dom';
import Incidents from '@/modules/common/pages/Incidents.tsx';
import Meetings from '@/modules/common/pages/Meetings.tsx';
import SecretManager from '@/modules/common/pages/SecretManager.tsx';
import SecretManagerVault from '@/modules/common/pages/SecretManagerVault.tsx';
import AdminComplianceDashboardWrapper from '@/modules/admin-dashboard/components/AdminComplianceDashboardWrapper.tsx';
import AIChat from '@/modules/admin-dashboard/pages/AIChat.tsx';
import AuditLog from '@/modules/admin-dashboard/pages/AuditLog.tsx';
import BatchReports from '@/modules/admin-dashboard/pages/BatchReports.tsx';
import Businesses from '@/modules/admin-dashboard/pages/Businesses.tsx';
import Client from '@/modules/admin-dashboard/pages/Client.tsx';
import Clients from '@/modules/admin-dashboard/pages/Clients.tsx';
import Communications from '@/modules/admin-dashboard/pages/Communications.tsx';
import ContractByID from '@/modules/admin-dashboard/pages/ContractByID.tsx';
import ContractManagement from '@/modules/admin-dashboard/pages/ContractManagement.tsx';
import Dashboard from '@/modules/admin-dashboard/pages/Dashboard.tsx';
import Department from '@/modules/admin-dashboard/pages/Department.tsx';
import Documents from '@/modules/admin-dashboard/pages/Documents.tsx';
import FixedReports from '@/modules/admin-dashboard/pages/FixedReports.tsx';
import Form from '@/modules/admin-dashboard/pages/Form.tsx';
import Forms from '@/modules/admin-dashboard/pages/Forms.tsx';
import { FormsByTag } from '@/modules/admin-dashboard/pages/FormsByTag.tsx';
import OnDemandReports from '@/modules/admin-dashboard/pages/OnDemandReports.tsx';
import Registers from '@/modules/admin-dashboard/pages/Registers.tsx';
import Tasks from '@/modules/admin-dashboard/pages/Tasks.tsx';
import TemplateReports from '@/modules/admin-dashboard/pages/TemplateReports.tsx';
import UserManagement from '@/modules/admin-dashboard/pages/UserManagement.tsx';

export const adminDashboardPaths = {
  static: {
    dashboard: '/admin/dashboard',
    departments: '/admin/departments',
    management: '/admin/user-management',
    forms: '/admin/forms',
    tasks: '/admin/tasks',
    fixedReports: '/admin/reports/fixed',
    onDemandReports: '/admin/reports/on-demand',
    templateReports: '/admin/reports/template',
    batchReports: '/admin/reports/batch',
    incidents: '/admin/events',
    registers: '/admin/registers',
    meetings: '/admin/meetings',
    organizationsSettings: '/admin/organizations-settings',
    documents: '/admin/documents',
    communications: '/admin/communications',
    aiChat: '/admin/ai-chat',
    clients: '/admin/clients',
    contractManagement: '/admin/contract-management',
    auditLog: '/admin/audit-log',
    secretManager: '/admin/secret-manager',
  },
  dynamic: {
    form(id?: string | number) {
      return `/admin/forms/${id || ':id'}`;
    },
    formsByTag(tagId?: string | number) {
      return `/admin/forms-by-tag/${tagId || ':id'}`;
    },
    taskCategory(category?: string) {
      return `/admin/tasks/${category || ':category'}`;
    },
    client(id?: string | number) {
      return `/admin/clients/${id || ':id'}`;
    },
    contract(id?: string | number) {
      return `/admin/contract-management/${id || ':id'}`;
    },
    secretVault(vaultId?: string | number) {
      return `/admin/secret-manager/${vaultId || ':vaultId'}`;
    },
  },
};

export const getDashboardRoutes = (): RouteObject[] => [
  {
    element: <AdminComplianceDashboardWrapper />,
    children: [
      { path: adminDashboardPaths.static.dashboard, element: <Dashboard /> },
      { path: adminDashboardPaths.static.departments, element: <Department /> },
      { path: adminDashboardPaths.static.management, element: <UserManagement /> },
      { path: adminDashboardPaths.static.forms, element: <Forms /> },
      { path: adminDashboardPaths.static.clients, element: <Clients /> },
      {
        path: adminDashboardPaths.static.contractManagement,
        element: <ContractManagement />,
      },
      { path: adminDashboardPaths.dynamic.contract(), element: <ContractByID /> },
      { path: adminDashboardPaths.static.communications, element: <Communications /> },
      { path: adminDashboardPaths.dynamic.client(), element: <Client /> },
      { path: adminDashboardPaths.dynamic.form(), element: <Form /> },
      { path: adminDashboardPaths.static.tasks, element: <Tasks /> },
      { path: adminDashboardPaths.dynamic.taskCategory(), element: <Tasks /> },
      { path: adminDashboardPaths.static.fixedReports, element: <FixedReports /> },
      { path: adminDashboardPaths.static.onDemandReports, element: <OnDemandReports /> },
      { path: adminDashboardPaths.static.templateReports, element: <TemplateReports /> },
      { path: adminDashboardPaths.static.batchReports, element: <BatchReports /> },
      { path: adminDashboardPaths.static.incidents, element: <Incidents /> },
      { path: adminDashboardPaths.static.registers, element: <Registers /> },
      { path: adminDashboardPaths.static.meetings, element: <Meetings /> },
      { path: adminDashboardPaths.dynamic.formsByTag(), element: <FormsByTag /> },
      { path: adminDashboardPaths.static.organizationsSettings, element: <Businesses /> },
      { path: adminDashboardPaths.static.documents, element: <Documents /> },
      { path: adminDashboardPaths.static.aiChat, element: <AIChat /> },
      { path: adminDashboardPaths.static.auditLog, element: <AuditLog /> },
      { path: adminDashboardPaths.static.secretManager, element: <SecretManager /> },
      { path: adminDashboardPaths.dynamic.secretVault(), element: <SecretManagerVault /> },
    ],
  },
];
